import { FormControl, FormLabel, Input, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { brandPalette } from "../../constants/brandPalette";

const MainInput = ({
  label,
  error,
  placeholder,
  register,
  name,
  type = "text",
  defaultValues,
  required = true,
  requiredMessage = "هذه المعلومات مطلوبة",
}) => {
  return (
    <FormControl isInvalid={Boolean(error)} data-exam-field={name}>
      <VStack align="stretch" spacing={2}>
        {label && (
          <FormLabel
            m={0}
            htmlFor={name}
            fontSize="14px"
            fontWeight="700"
            color="var(--text-primary)"
            textAlign="left"
          >
            {label}
          </FormLabel>
        )}
        <Input
          id={name}
          type={type}
          borderColor={error ? "red.400" : "var(--border-subtle)"}
          placeholder={placeholder}
          size="md"
          bg="var(--surface-muted)"
          color="var(--text-primary)"
          border="1px solid"
          borderRadius="lg"
          _focus={{
            borderColor: error ? "red.400" : brandPalette.primary,
            boxShadow: error
              ? "0 0 0 1px var(--chakra-colors-red-400)"
              : "0 0 0 1px rgba(91, 13, 22, 0.22)",
          }}
          _placeholder={{ color: "var(--text-muted)" }}
          defaultValue={defaultValues}
          {...register(name, required ? { required: requiredMessage } : {})}
        />
        {error ? (
          <Text color="red.500" fontSize="sm" fontWeight="600">
            {error}
          </Text>
        ) : null}
      </VStack>
    </FormControl>
  );
};

export default MainInput;